import { useState } from "react";
import { Box } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import TopBar from "../../components/Admin/TopBar";
import AdminHome from "../../components/Admin/AdminHome";
import CompetitionManager from "../../components/Admin/Competition/CompetitionManager";
import MatchesManager from "../../components/Admin/Matches/MatchesManager";
import LiveMatchControl from "../../components/Admin/Matches/LiveMatchControl";
import GalleryManager from "../../components/Admin/Gallery/GalleryManager";

const drawerWidth = 280;

export default function AdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "background.default" }}>
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        drawerWidth={drawerWidth}
      />

      <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />

        <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
          <Routes>
            <Route index element={<AdminHome />} />
            <Route path="competition" element={<CompetitionManager />} />
            <Route path="matches" element={<MatchesManager />} />
            <Route path="matches/live/:match_id" element={<LiveMatchControl />} />
            <Route path="gallery" element={<GalleryManager />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}